var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button as MuiButton, CircularProgress, makeStyles, withStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
const Spinner = withStyles({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
})(CircularProgress);
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: (props) => (props.variant === "muted" ? "red" : null),
        textTransform: (props) => (props.lowercase ? "none" : null)
    },
    buttonIcon: {
        marginLeft: ".5em",
        marginRight: "-.5em",
        transform: "translateY(0.03em)"
    },
    oval: {
        padding: "0 16px",
        height: "28px",
        borderRadius: "12px",
        background: (props) => props.color
            ? null
            : theme.palette.type === "dark"
                ? theme.palette.secondary.dark
                : theme.palette.primary.dark,
        color: theme.palette.common.white,
        border: "none",
        fontSize: "13px",
        fontWeight: 600,
        transition: "all 0.15s ease",
        "&:hover": {
            background: (props) => props.color ? null : theme.palette.type === "dark" ? "#252c34" : "#010f1f"
        }
    }
}));
const getColor = (color) => {
    if (color) {
        if (color === "white") {
            return "default";
        }
        return color;
    }
    return "primary";
};
export const Button = (props) => {
    const classes = useStyles(props);
    const { color, className, variant, disabled, loading, icon, component, style, children, lowercase } = props, other = __rest(props, ["color", "className", "variant", "disabled", "loading", "icon", "component", "style", "children", "lowercase"]);
    const buttonClassName = classNames(className, classes.root, variant === "oval" ? classes.oval : null);
    const getVariant = () => {
        if (variant === "muted" || variant === "oval") {
            return "contained";
        }
        return variant || "contained";
    };
    return (React.createElement(MuiButton, Object.assign({ className: buttonClassName, color: getColor(color), variant: getVariant(), disabled: disabled || loading, component: component, style: style }, other),
        children,
        typeof icon === "object" && React.createElement("div", { className: classes.buttonIcon }, icon),
        loading && React.createElement(Spinner, { size: 24 })));
};
export default Button;
//# sourceMappingURL=Button.js.map